// extracted by mini-css-extract-plugin
export default {"clientMenuContainer":"ClientMenuIconStyles_clientMenuContainer__JJ2uV","clientMenuIcon":"ClientMenuIconStyles_clientMenuIcon__mYBwA"};